export default __webpack_public_path__ + "static/media/light-bulb.b618fd5d.png";